let React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import HandelSOWBillingReport from './HandelSOWBillingReport'
import {logger, handleExport, customBodyForExcelReport,checkAuthentication,muiLoaderOptions} from '../../utils';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));

const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 16px',
            position: 'sticky',
            top: 0,
            backgroundColor: '#fff',
            zIndex: 130,
            borderBottom: '1px solid #e0e0e0',
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          root: {
            position: 'sticky',
            top: 56, // match toolbar height
            backgroundColor: '#fff',
            zIndex: 120,
          },
        },
      },
    },
  });


export default function ExpenseReport() {
    const classes = pageStyles();
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [display, setDisplay] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [fullScreen, setFullScreen] = React.useState(false);

    const toggleFullscreen = () => {
        setIsFullscreen(prev => !prev);
    };

    React.useEffect(() => {
        const getData = async () => {
            await fetch(`/api/expenses`, {
                method: 'GET',
            })
            .then(res => res.json())
            .then(json => {
                setDataSet(json);
                setIsLoading(false);
            });
        };

        checkAuthentication();
        if (refresh) {
            getData();
            setRefresh(false);
        }
    }, [refresh]);

    const columns = [
       {
            name: "Name",
            label: "Expense Name",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "InvoiceNumber",
            label: "Invoice",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "LabName",
            label: "Lab",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Comment",
            label: "Comment",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Amount",
            label: "Amount",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex) => parseFloat(dataSet[dataIndex].Amount).toFixed(2)
            }
        },
        {
            name: "Date",
            label: "Date",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex) =>
                    moment.utc(dataSet[dataIndex].Date).format("MM/DD/YYYY")
            }
        }
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100;
    };

    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    };

    const initialRowsPerPage = getSavedRowsPerPage();

    const baseOptions = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'standard',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "auto",
        tableBodyMaxHeight: "auto",
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        textLabels: {
            toolbar: {
                search: "Search",
                downloadCsv: "Download Excel",
                print: "Print",
                viewColumns: "View Columns",
                filterTable: "Filter Table",
            },
        },
        selectableRows: 'none',
        onChangeRowsPerPage: (newRowsPerPage) => {
            saveRowsPerPage(newRowsPerPage);
        },
        onDownload: (buildHead, buildBody, columns, data) => {
            const customBuildHead = () => columns.map(col => col.label);
            const customBuildBody = () => {
                const headers = customBuildHead();
                return customBodyForExcelReport({ data, headers });
            };
            const headers = customBuildHead();
            const rows = customBuildBody();
            handleExport({ rows, headers, filename: 'ExpenseReport.xlsx' });
            return false;
        }
    };

	var options = {};
	if (!fullScreen) {
		options = {
			...baseOptions,
			customToolbarTitle: CustomToolbarTitle,
			tableBodyHeight: "450px",
			tableBodyMaxHeight: "1000px",
			responsive: 'standard',
		}
	} else {
		options = {
			...baseOptions,
			responsive: 'standard',
			tableBodyHeight: "800px",
			tableBodyMaxHeight: "84vh",
			rowsPerPage: initialRowsPerPage,
			selectableRows: 'none',
		}
	}

	const handleClickOpen = () => {
        setRefresh(true);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setIsFullscreen(false); 
    };
    
     const handleMinimize = () => {
		setFullScreen(false);
	};
	
	const CustomToolbarTitle = () => (
		<Typography variant="h6" sx={{ fontWeight: 'bold', flexGrow: 1 }}>
			Report All Time Entries
		</Typography>
	);

	const handleMaximize = () => {
		setFullScreen(true);
	};


    return (
        <div className={classes.root}>
            <Button variant="contained" onClick={handleClickOpen}>
                Expense Report
            </Button>
            <MuiThemeProvider theme={muiThemeDesign}>
              <Dialog
							className={classes.root}
                    		open={open}
                    		onClose={handleClose}
							fullScreen={fullScreen}
							fullWidth
							maxWidth={fullScreen ? false : 'xl'}
							scroll="paper"
							PaperProps={{
								style: {
									height: fullScreen ? '100vh' : '70vh',
									margin: fullScreen ? 0 : '5vh auto',
									borderRadius: fullScreen ? 0 : 10,
									overflow: 'hidden',
									display: 'flex',
									flexDirection: 'column',
								}
							}}
						>
						<DialogContent
							sx={{
								p: 0,
								flex: 1,
								display: 'flex',
								flexDirection: 'column',
								overflow: 'hidden',
							}}>
							<Box
								sx={{
									flex: 1,
									overflowY: 'auto',
									overflowX: 'hidden',
									position: 'relative',
								}}>
								<ThemeProvider theme={getMuiTheme()}>
									<MUIDataTable 
										title={
											<Box>
												<Typography variant="h6" style={{ color: "white" }}>
													<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close"> <CloseIcon /> </IconButton>
													<Tooltip title={fullScreen ? 'Minimize' : 'Maximize'}>
														<IconButton
															color="inherit"
															onClick={fullScreen ? handleMinimize : handleMaximize}
														>
															{fullScreen ? <CloseFullscreenIcon /> : <FullscreenIcon />}
														</IconButton>
													</Tooltip>
													 Expense Report 
												</Typography>
											</Box>
										}
										data={isLoading ? [] : dataSet}
										columns={columns}
										options={muiLoaderOptions(options, isLoading)}
									/>
								</ThemeProvider>
                            </Box>
                        </DialogContent>
                    </Dialog>
            </MuiThemeProvider>
        </div>
    );
}